import { TimePicker as TimePickerComponent, type TimePickerProperties } from '@pba/react-components';
import cn from 'classnames';

const TimePicker = ({ className, ...inputRest }: TimePickerProperties) => (
  <TimePickerComponent
    className={cn(className, 'ui-time-input')}
    classNames={{ popup: { root: 'ui-time-input-popup' } }}
    needConfirm={false}
    showNow={false}
    {...inputRest}
  />
);

export default TimePicker;
